import React from 'react'
import { Card, CardActions, CardContent, CardHeader, Fade, IconButton, TextField, Typography, withStyles } from '@material-ui/core'
import { useContext } from 'react'
import { GameContext } from '../GameProvider'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
import { SettingsContext } from '../../../Parts/Settings'
import SendIcon from '@material-ui/icons/Send'
import { getWord, WID } from '../../../constants/Language'
import { useState } from 'react'
import { useRef } from 'react'
import { useEffect } from 'react'

const messageBoxHeight = 200
const scrollTime = 300
const fps = 100

const stylesGroupChatCard = (theme) => ({
  cardHeader: {
    backgroundColor: theme.palette.grey[100]
  },
  cardContent: {
    height: messageBoxHeight,
    overflowY: 'scroll',
    boxSizing: 'border-box',
  },
  messageBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    fontSize: '1em',
  },
  chatActionsBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing.unit,
  },
  textMessageField: {
    width: '100%',
    maxWidth: 'calc(100% - 100px)',
  },
  chatDisplayName: {
    display: 'inline-block',
    maxWidth: '100px',
    marginRight: theme.spacing.unit,
    color: theme.palette.grey[600],
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'bottom',
  },
  chatMessage: {
  },
})

function GroupChatCard(props) {
  var groupUsers, groupChat
  const { classes } = props

  const [isInitialized, setIsInitialized] = useState(false)
  const [message, setMessage] = useState('')
  const [scrollDiff, setScrollDiff] = useState(undefined)
  const [scrollStart, setScrollStart] = useState(undefined)
  const [frameCount, setFrameCount] = useState(0)
  const [time, setTime] = useState(Date.now())
  const [isScrolled, setIsScrolled] = useState(false)
  const [intervalId, setIntervalId] = useState(undefined)

  const gameContext = useContext(GameContext)
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  groupUsers = gameContext.getGroupUsers()
  groupChat = gameContext.getGroupChat(gameContext.selectedGroup)

  const prevIsScrolled = useRef(isScrolled)
  const prevGroupChat = useRef(groupChat)

  var obj = document.getElementById('messagesBox')
  var diff = obj ? obj.scrollHeight - messageBoxHeight - obj.scrollTop : 0

  useEffect(() => {
    if (!isInitialized) {
      var obj = document.getElementById('messagesBox')
      if (obj) {
        obj.scrollTop = obj.scrollHeight
      }
      setIsInitialized(true)
    }
  }, [isInitialized])

  useEffect(() => {
    if (
      groupChat && prevGroupChat.current &&
      groupChat.length > prevGroupChat.current.length &&
      (0 === diff || isScrolled)
    ) {
      setTimeout(() => {
        obj = document.getElementById('messagesBox')
        if (obj) {
          setScrollDiff(obj.scrollHeight - messageBoxHeight - obj.scrollTop)
          setScrollStart(obj.scrollTop)
          setFrameCount(1)
          setIsScrolled(true)
        }
      }, 1)
    }

    prevGroupChat.current = groupChat
  }, [groupChat])

  useEffect(() => {
    if (isScrolled && !prevIsScrolled.current.isScrolled) {
      setIntervalId(setInterval(() => setTime(Date.now()), 1000 / fps))
    }
    if (!isScrolled && prevIsScrolled.current.isScrolled) {
      clearInterval(intervalId)
    }
    if (isScrolled) {
      var obj, rate
      obj = document.getElementById('messagesBox')

      if (obj) {
        rate = frameCount / (scrollTime * fps / 1000)
        diff = obj.scrollHeight - messageBoxHeight - obj.scrollTop
        if (1 >= rate) {
          obj.scrollTop = scrollStart + scrollDiff * rate * (2 - rate)
          setFrameCount(frameCount + 1)
        }
        else {
          setIsScrolled(false)
        }
      }
    }
    prevIsScrolled.current = { isScrolled, time }
  }, [isScrolled, time])

  const handleCancelScroll = () => {
    if (isScrolled) {
      setIsScrolled(false)
    }
  }

  const handleKeyDown = (event) => {
    if (event.keyCode === 13){
      gameContext.groupChatMessage(gameContext.selectedGroup, message)
      setMessage('')
    }
  }

  const handleClickSendMessage = (event) =>{
    gameContext.groupChatMessage(gameContext.selectedGroup, message)
    setMessage('')
  }

  return (
    <Fade in={Boolean(groupUsers.length > 0)}>
      <Card className={classes.root}>
        <CardHeader className={classes.cardHeader} subheader={'Chat'}>
        </CardHeader>
        <CardContent
          className={classes.cardContent}
          id='messagesBox'
          onMouseDown={handleCancelScroll}
          onTouchStart={handleCancelScroll}
          onWheel={handleCancelScroll}
        >
          {groupChat.map((chat, index) => 
            <div className={classes.messageBox} key={index}>
              <CustomAvatar
                alt={chat.user.displayName}
                name={chat.user.displayName}
                src={chat.user.avatarPhotoURL}
                className={classes.avatar}
              />
              <Typography color='inherit'>
                <span className={classes.chatDisplayName}>{chat.user.userName}</span>
                <span className={classes.chatMessage}>{chat.message}</span>
              </Typography>
            </div>
          )}
        </CardContent>
        <CardActions className={classes.chatActionsBox}>
            <TextField
              className={classes.textMessageField}
              placeholder={getWord(WID.GAME_INFO_CARD.CHAT_BOX.ENTER_A_MESSAGE, language)}
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              onKeyDown={handleKeyDown}
              disabled={Boolean(!settingsContext.userSettings)}
            />
            <IconButton
              color="primary"
              disabled={Boolean(message === '' || !settingsContext.userSettings)}
              onClick={handleClickSendMessage}
            >
              <SendIcon/>
            </IconButton>
        </CardActions>
      </Card>
    </Fade>
  )
}

export default withStyles(stylesGroupChatCard, { withTheme: true })(GroupChatCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GroupChatCard.js